import { render } from "./MiniStatisticsCard.vue?vue&type=template&id=2a8cd232"
import script from "./MiniStatisticsCard.vue?vue&type=script&lang=js"
export * from "./MiniStatisticsCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/nbignu/Escritorio/HT/proyectos HT - usa/proyectos HT/proyectos HT/proyectos HT walii y ts/EmailAI/WebApp/vue-soft-ui-dashboard-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__